var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { createSvgIconFromGenerated } from '../utils';
var SvgBigPhone = function SvgBigPhone(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    width: "1em",
    height: "1em",
    focusable: "false",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 36,
    r: 28,
    fillOpacity: 0.12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M32 4c15.464 0 28 12.536 28 28S47.464 60 32 60a27.89 27.89 0 0 1-11.696-2.553L20 57.305C10.54 52.811 4 43.17 4 32 4 16.69 16.287 4.251 31.537 4.004L32 4Zm10 17H22v35.007A25.92 25.92 0 0 0 32 58a25.92 25.92 0 0 0 10-1.993V21ZM32 52a2 2 0 1 1 0 4 2 2 0 0 1 0-4Zm0-46C17.64 6 6 17.64 6 32c0 10.03 5.68 18.735 14 23.07V21a2 2 0 0 1 2-2h20a2 2 0 0 1 2 2v34.071C52.32 50.735 58 42.031 58 32 58 17.64 46.36 6 32 6Zm1 17a1 1 0 1 1 0 2h-2a1 1 0 1 1 0-2h2Z",
    clipRule: "evenodd"
  })));
};
export default createSvgIconFromGenerated(SvgBigPhone, "BigPhone");